import { getbanners } from "@/api/home"
import {SERVER_URL} from '@/util/urlConfig'
export default {
  namespaced: true,
  state:{
    loading: true,
    data: []
  },
  mutations: {
    SET_LOADING(state, payload){
      state.loading = payload;
    },
    SET_DATA(state,payload){
      state.data = payload;
    }
  },
  actions: {
    async fetchBanner(ctx){
      if(ctx.state.data.length) return
      ctx.commit('SET_LOADING', true);
      let res = await getbanners();
      console.log(res)
      res = res.map((e) =>{
        return {
          ...e,
          bigImg: SERVER_URL + e.bigImg,
          midImg: SERVER_URL + e.midImg
        }
      })
      ctx.commit('SET_DATA', res)
      ctx.commit('SET_LOADING', false);
    }
  }
}